export default __webpack_public_path__ + "static/media/pub.c9af6a74.svg";